(() => {
  'use strict';
  const startsAt = 1793741070000;
  const endsAt = 1796108400000;
  const products = new Map();
  const cards = new Map();
  const badges = new Map();
  let serverOffset = 0;
  let timer;
  const now = () => Math.max(Date.now(), serverOffset + performance.now());
  const active = () => now() >= startsAt && now() < endsAt;
  const rememberTime = element => {
    serverOffset = Math.max(serverOffset,
      Number(element.dataset.ckBfNow || 0) * 1000 - performance.now());
  };
  const currency = () => window.Shopify?.currency?.active || 'USD';
  const quantum = () => {
    const decimals = new Intl.NumberFormat('en', {
      style: 'currency', currency: currency()
    }).resolvedOptions().maximumFractionDigits;
    return 10 ** (2 - Math.min(2, decimals));
  };
  const salePrice = (price, rule, amount) => {
    const unit = quantum();
    const rate = currency() === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    if (rule === 'amount' && !(rate > 0)) return null;
    const discount = rule === 'percentage'
      ? Math.round(price * 0.2 / unit) * unit
      : Math.round(amount * rate / unit) * unit;
    return Math.max(0, price - discount);
  };
  const money = amount => {
    if (window.Shopify?.formatMoney && window.Theme?.moneyFormat) {
      return window.Shopify.formatMoney(amount, window.Theme.moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency()
    }).format(amount / 100);
  };
  const setMoney = (element, amount) => {
    if (!element) return;
    const html = money(amount);
    if (element.innerHTML !== html) element.innerHTML = html;
  };
  const updateProduct = (element, entry) => {
    const selected = entry.root.querySelector('select[name="id"]');
    const variant = entry.variants[selected?.value || element.dataset.ckBfCurrent];
    if (!variant) return;
    const isActive = active();
    const discounted = isActive
      ? salePrice(variant.price, element.dataset.ckBfRule, Number(element.dataset.ckBfAmount))
      : variant.price;
    if (discounted === null) return;
    const retail = isActive && element.dataset.ckBfRule === 'percentage'
      ? variant.price : variant.compare;
    const priceNode = element.querySelector('[data-product-price]');
    const compareNode = element.querySelector('[data-product-price-compare]');
    setMoney(priceNode, discounted);
    priceNode?.classList.toggle('is-sale', isActive);
    setMoney(compareNode, retail);
    compareNode?.classList.toggle('hidden', !(retail > discounted));
    const label = element.querySelector('[data-ck-bf-label]');
    const labelText = retail > discounted
      ? element.dataset.ckBfSaleLabel : element.dataset.ckBfRegularLabel;
    if (label && label.textContent !== labelText) label.textContent = labelText;
    if (variant.unitPrice) {
      setMoney(element.querySelector('.unit-price__price'),
        isActive ? Math.round(variant.unitPrice * discounted / variant.price) : variant.unitPrice);
    }
  };
  const update = () => {
    for (const [element, entry] of products) {
      if (!element.isConnected) { entry.observer.disconnect(); products.delete(element); continue; }
      updateProduct(element, entry);
    }
    for (const [element, entry] of cards) {
      if (!element.isConnected) { cards.delete(element); continue; }
      if (!active()) {
        element.innerHTML = entry.normal;
        cards.delete(element);
        element.removeAttribute('data-ck-bf-card');
      } else {
        const price = salePrice(Number(element.dataset.ckBfPrice),
          element.dataset.ckBfRule, Number(element.dataset.ckBfAmount));
        if (price !== null) setMoney(element.querySelector('[data-ck-bf-sale]'), price);
      }
    }
    for (const [element, normal] of badges) {
      if (!element.isConnected) { badges.delete(element); continue; }
      if (!active()) {
        element.textContent = normal;
        element.hidden = !normal;
        badges.delete(element);
        element.removeAttribute('data-ck-bf-badge');
      }
    }
    clearTimeout(timer);
    if (active()) timer = setTimeout(update, Math.min(endsAt - now() + 20, 2147483000));
  };
  const scan = container => {
    const query = selector => [
      ...(container.matches?.(selector) ? [container] : []),
      ...container.querySelectorAll(selector)
    ];
    for (const element of query('[data-ck-bf-product]')) {
      if (products.has(element)) continue;
      rememberTime(element);
      const root = element.closest('[data-product-json]');
      if (!root) continue;
      let variants;
      try { variants = JSON.parse(element.dataset.ckBfVariants); } catch { continue; }
      const entry = { root, variants };
      entry.observer = new MutationObserver(() => updateProduct(element, entry));
      entry.observer.observe(element, { childList: true, subtree: true, characterData: true });
      root.querySelectorAll('form').forEach(form =>
        form.addEventListener('change', () => updateProduct(element, entry)));
      products.set(element, entry);
    }
    for (const element of query('[data-ck-bf-card]')) {
      if (cards.has(element)) continue;
      rememberTime(element);
      cards.set(element, { normal: element.dataset.ckBfNormal });
    }
    for (const element of query('[data-ck-bf-badge]')) {
      if (badges.has(element)) continue;
      rememberTime(element);
      badges.set(element, element.dataset.ckBfNormal || '');
    }
    update();
  };
  const init = () => {
    scan(document);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === 1) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
    document.addEventListener('shopify:section:load', event => scan(event.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

